export function randomInteger(min: number, max: number): number {
    return Math.round(min - 0.5 + Math.random() * (max - min + 1));
}

export function randomString(length: number, alphabet?: string): string {
    const characters = alphabet ?? 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    let result = '';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(randomInteger(0, characters.length));
    }

    return result;
}
